var _path, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 18,
    viewBox: "0 0 19 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_50_300)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_50_300)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_50_300",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 19,
    height: 18
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.40979 0H18.4098V18H0.40979V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_50_300)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.76679 15.8845L11.8168 11.3875L16.5748 9.99354L12.9118 6.66354L13.0498 1.72754L8.73679 4.16554L4.06379 2.50954L5.06079 7.34654L2.03479 11.2595L6.96479 11.8105L9.76679 15.8845ZM13.9758 13.5195L16.9758 16.5065L13.9758 13.5195Z",
    fill: "#FF5147"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.76679 15.8845L11.8168 11.3875L16.5748 9.99354L12.9118 6.66354L13.0498 1.72754L8.73679 4.16554L4.06379 2.50954L5.06079 7.34654L2.03479 11.2595L6.96479 11.8105L9.76679 15.8845ZM13.9758 13.5195L16.9758 16.5065L13.9758 13.5195Z",
    fill: "url(#paint0_radial_50_300)"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_50_300",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.5244 2.26823) rotate(90.0769) scale(14.2383 14.3944)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79D9FD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#357CD2"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_50_300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.40979)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_50_300"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18,
    height: 18,
    fill: "white",
    transform: "translate(0.40979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStart);
export default __webpack_public_path__ + "static/media/start.80363e32987e9176b81dd815a58cf925.svg";
export { ForwardRef as ReactComponent };